module.exports = __webpack_public_path__ + "img/id-verified.b6856e26.jpg";